import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichTextBox.css';

const RichTextBox = ({ label, defaultValue = '', onChange, validators = [],error }) => {
    const [value, setValue] = useState(defaultValue);
    const [errors, setErrors] = useState([]);
  
    const handleChange = (content) => {
      // Validate on change
      const newErrors = validators
        .map((validator) => (typeof validator === 'function' ? validator(content) : null))
        .filter((error) => typeof error === 'string');
  
      setErrors(newErrors);
  
      if (newErrors.length === 0) {
        setValue(content);
        if (onChange) {
          onChange(content, newErrors);
        }
      }
    };
  
    const displayErrors = error ? [error] : errors;

    return (
      <div className='rich-text-box-container fts-15 common-text ftw-4'>
        <label className={`rich-text-label fts-15 common-text ftw-4 ${value ? 'has-value' : ''}`}>{label}</label>
        <ReactQuill 
          value={value}
          onChange={handleChange}
          className="rich-text-editor"
        />
       {displayErrors.length > 0 && (
        <div className="input-error-message fts-12">
          {displayErrors[0]}
        </div>
      )}
      </div>
    );
  };
  
  export default RichTextBox;